import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import editIcon from "../../assets/img/edit.svg";
import { AuthContext } from "../../AuthProvider/AuthProvider";

const WriteBlog = () => {
  const { user } = useContext(AuthContext);

  const [blogs, setBlogs] = useState();
  useEffect(() => {
    fetch("https://youtube-api-blog-site-server.vercel.app/blogs")
      .then((res) => res.json())
      .then((data) => setBlogs(data));
  }, []);

  const [title, setTitle] = useState();
  const [img, setImg] = useState();
  const [blogText, setBlogText] = useState();

  const handleSubmit = () => {
    const blog = { title, img, blogText };

    fetch("https://youtube-api-blog-site-server.vercel.app/blogs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(blog),
    })
      .then((res) => res.json())
      .then((data) => {
        setBlogs([...blogs, data]);
      });
  };

  const handleDelete = (blog) => {
    // console.log(blog);
    const agree = window.confirm(`Are you sure to delete '${blog.title}'`);
    if (agree) {
      fetch(`https://youtube-api-blog-site-server.vercel.app/blogs/${blog._id}`, {
        method: "DELETE",
      })
        .then((res) => res.json())
        .then((data) => {
          const reaming = blogs.filter((blg) => blg._id !== blog._id);
          setBlogs(reaming);
        });
    }
  };
  const adminList = ["admin@gmail.com", "Rimon@admin.com", "maruf@gmail.com"];

  return (
    <div>
      <h1 className="text-center font-bold md:text-5xl text-2xl md:m-10 m-1 italic">
        Blogs
      </h1>
      {/* ---------new+ blog */}
      {adminList.includes(user?.email) && (
        // {user && (
        <>
          <div className="flex justify-end md:mr-10 mr-4">
            <label htmlFor="my-modal-3" className="">
              <div className="btn md:btn-md btn-sm gap-2">
                Write new
                <div className="badge badge-secondary">+</div>
              </div>
            </label>
          </div>
        </>
      )}

      {/* -------------------write blog-------------- */}
      <input type="checkbox" id="my-modal-3" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box relative">
          <label
            htmlFor="my-modal-3"
            className="btn btn-sm btn-circle absolute right-2 top-2"
          >
            ✕
          </label>
          <h3 className="text-lg font-bold text-center">Write a Blog!</h3>
          <div className="flex gap-2  mt-5">
            <input
              onChange={(e) => setTitle(e.target.value)}
              type="text"
              placeholder="Your blog title..."
              className="input input-sm input-bordered input-accent w-full max-w-xs"
            />
            <input
              onChange={(e) => setImg(e.target.value)}
              type="text"
              placeholder="blog cover image link(400x225)"
              className="input input-sm input-bordered input-accent w-full max-w-xs"
            />
          </div>
          <textarea
            onChange={(e) => setBlogText(e.target.value)}
            className="textarea textarea-accent w-full h-48 py-4 mt-10 text-lg"
            placeholder="Let's Start...."
          ></textarea>
          <button onClick={handleSubmit} className="btn btn-accent btn-sm mt-3">
            <label htmlFor="my-modal-3">Post</label>
          </button>
        </div>
      </div>

      {/* ---------------------------------blogs----------------------------------------- */}
      <div className="flex flex-col flex-wrap max-w-screen-xl lg:flex-row my-10 mx-auto gap-3 ">
        {/* ----blog cover---- */}
        {blogs?.map((blog) => (
          <div key={blog._id}>
            <div className="card md:w-96 w-80 mx-auto bg-slate-200 shadow-2xl text-black">
              <figure className="md:w-96 w-80 md:h-[220px] h-44">
                <img className="" src={blog.img} alt="Shoes" />
              </figure>
              <div className="card-body pl-4 pt-4">
                <h2 className=" card-title text-center mx-auto">
                  {blog.title}
                </h2>
                <p className="text-center">{blog.blogText?.slice(0, 200)}...</p>
                <div className="card-actions justify-end items-center mt-4 gap-3">
                  {/* admin access only */}
                  {adminList.includes(user?.email) && (
                    <div className="flex gap-5 items-center ">
                      <div className="" onClick={() => handleDelete(blog)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          className="cursor-pointer inline-block w-6 h-6 stroke-current text-[#005FFF] "
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                          ></path>
                        </svg>
                      </div>
                      <Link to={`/update/${blog._id}`}>
                        <img
                          className="cursor-pointer w-6 h-6"
                          src={editIcon}
                          alt=""
                        />
                      </Link>
                    </div>
                  )}

                  <label htmlFor="my-modal-5">
                    <Link
                      to={`/blogs/${blog._id}`}
                      className="badge badge-lg cursor-pointer bg-indigo-600 text-white py-4 px-5 ml-2"
                    >
                      Read Now
                    </Link>
                  </label>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WriteBlog;
